
import sentry from './instrument'
sentry()

import '../css/app.css';

import { createInertiaApp, router } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { StagingBanner } from './components/staging-banner';
import { LanguageProvider } from './contexts/LanguageContext';
import { initializeTheme } from './hooks/use-appearance';
import { runtimeEnv } from '@/lib/runtime-env';
import './i18n';
const appName = runtimeEnv('VITE_APP_NAME') || 'Laravel';

createInertiaApp({
    title: (title) => (title ? `${title} - ${appName}` : appName),
    resolve: (name) =>
        resolvePageComponent(
            `./pages/${name}.tsx`,
            import.meta.glob('./pages/**/*.tsx'),
        ),
    setup({ el, App, props }) {
        const root = createRoot(el);
        root.render(
            <StrictMode>
                <Toaster style={{ zIndex: 10000 }} position="top-left" />
                <StagingBanner isStaging={!!props.initialPage.props.isStaging} />
                <LanguageProvider>
                    <App {...props} />
                </LanguageProvider>
            </StrictMode>,
        );

        // Track every Inertia navigation as a GA4 page_view.
        // Registered once here (outside React) so it never duplicates.
        // Requires send_page_view:false in the Blade gtag config snippet.
        router.on('navigate', (event) => {
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'page_view', {
                    page_location: event.detail.page.url,
                    page_title: document.title,
                });
            }
        });
    },
    progress: {
        color: '#4B5563',
    },
});

// This will set light / dark mode on load...
initializeTheme();
